/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import { Grid, Typography, Box, Container } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import '../Main.style.css';

const InvitationLinkExpired = (props) => {
  const { reason } = useParams();
  return (
    <Container>
      {
        <Box className="PageSpacing">
          <Grid container direction="row" className="InvitationExpiredcontainer">
            <Grid item xs={12}>
              <Typography
                color="primary"
                variant="h2"
                className="InvitationExpiredTitle FlexCenter"
              >
                Uh oh. This link has expired.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography className="InvitationExpiredContent FlexCenter">
                {(reason === 'accepted' &&
                  'The link you are trying to access expires after account creation.') ||
                  ''}
                {(reason === 'expired' &&
                  'The link you are trying to access expires after 14 days for security reasons.') ||
                  ''}
                {(reason === 'cancelled' &&
                  'The link you are trying to access has been cancelled by the admin.') ||
                  ''}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      }
    </Container>
  );
};
InvitationLinkExpired.defaultProps = {
  showSearch: true,
  tabValue: 0,
};
export default InvitationLinkExpired;
